"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_tag_1 = __importDefault(require("./get-tag"));
function isUint32Array(value) {
    return ArrayBuffer.isView(value) && (0, get_tag_1.default)(value) === '[object Uint32Array]';
}
exports.default = isUint32Array;
//# sourceMappingURL=is-uint32array.js.map